import { $api } from '@service/RequestService';
import { dateToTimeStamp } from '@utils/index';
import { useMutation } from 'react-query';

export const useLeadTaskSaveGroup = () =>
  useMutation(
    async ({
      deadlineStart,
      deadlineFinish,
      ...data
    }: {
      leadTaskTypeId: number;
      assignedById: number;
      deadlineStart: string;
      deadlineFinish: string;
      text: string;
      debtFilterDto?: {
        contracts?: number[] | null;
        ignoreContracts?: number[] | null;
      };
    }) => {
      const res = await $api.post('/v1/lead-task/save-group', {
        ...data,
        deadlineStartTimestamp: dateToTimeStamp({ date: deadlineStart }),
        deadlineFinishTimestamp: dateToTimeStamp({ date: deadlineFinish })
      });

      return res?.data?.data;
    }
  );
